import { cn } from "@/lib/utils";

export function DislikeIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-3.5", className)}
      viewBox="0 0 14 14"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M10.213 6.98V1.62a.54.54 0 01.536-.534h2.41c.294 0 .537.24.537.534v5.36a.54.54 0 01-.536.537h-2.41a.54.54 0 01-.537-.537z"
        fill="#faa042"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M1.906 8.588h2.32c-.193.772-.712 1.066-.712 2.143 0 1.967 2.24 3.644 2.806.62.168-.814 2.021-3.761 2.846-3.826.277-.026.51-.26.51-.537V1.621a.55.55 0 00-.535-.535c-.293-.01-.796-.184-1.322-.369C6.913.407 5.783.013 4.586.013c-1.554 0-3.312-.29-3.138 1.904-.816.273-1.45 1.508-.816 2.45-.817.817-.67 1.629 0 2.45 0 0-.545 1.36 1.274 1.771z"
        fill="#ffc850"
        fillRule="evenodd"
      />
    </svg>
  );
}

export function LikeIcon({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-3.5", className)}
      viewBox="0 0 14 14"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M3.557 6.026v5.36a.54.54 0 01-.537.534H.61a.539.539 0 01-.537-.534v-5.36A.54.54 0 01.61 5.49h2.41a.54.54 0 01.537.537z"
        fill="#faa042"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M11.863 4.418h-2.32c.193-.772.712-1.066.712-2.143 0-1.967-2.24-3.644-2.805-.62-.169.814-2.022 3.761-2.846 3.826-.278.026-.51.26-.51.537v5.367a.55.55 0 00.534.535c.294.01.796.184 1.323.369.905.31 2.035.704 3.232.704 1.554 0 3.312.29 3.138-1.904.816-.273 1.45-1.508.816-2.45.817-.817.67-1.629 0-2.45 0 0 .545-1.36-1.274-1.771z"
        fill="#ffc850"
        fillRule="evenodd"
      />
    </svg>
  );
}

export function LoveIcon({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-[13px] w-3.5", className)}
      viewBox="0 0 14 13"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.573 12.097c.254 0 .642-.236 1.018-.49 3.27-2.175 5.482-4.792 5.482-7.409C13.073 1.66 11.286 0 9.25 0 7.978 0 7.094.697 6.573 1.678 6.058.703 5.167 0 3.895 0 1.86 0 .073 1.66.073 4.198c0 2.617 2.21 5.234 5.482 7.409.376.254.763.49 1.018.49z"
        fill="#faa042"
      />
      <path
        d="M3.895 0c1.272 0 2.163.703 2.678 1.678 0 0-7.851.532-1.018 9.929C2.284 9.432.073 6.815.073 4.198.073 1.66 1.86 0 3.895 0z"
        fill="#ffc850"
      />
    </svg>
  );
}
